module.exports = __webpack_public_path__ + "static/media/10-4--thumb.1bea54d6.png";